import * as React from 'react';
import { useClickOutside } from '../../../../providers/useClickOutside/useClickOutside';
import { usePopper } from '../../../../providers/usePopper/usePopper';
import { testIds } from '../../constants';
import { IFileErrorIconProps } from '../../FileUploader.types';
import { ReactComponent as InfoIcon } from './assets/infoIcon.svg';
import { ReactComponent as TooltipArrow } from './assets/tooltipArrow.svg';
import style from './style/FileErrorIcon.scss';

export const FileErrorIcon: React.FC<IFileErrorIconProps> = props => {
  const [isOpen, setOpen] = React.useState(false);
  const popper = usePopper<HTMLAnchorElement>({ placement: 'top' });

  const hideTooltip = () => setOpen(false);
  const showTooltip = () => setOpen(true);

  useClickOutside([popper.ref], hideTooltip);

  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = e => {
    e.preventDefault();
    setOpen(!isOpen);
  };

  const tooltipId = `${props.id}_tooltip`;

  return (
    <div
      className={style.tooltipContainer}
      data-testid={testIds.tooltipContainer}
    >
      <a
        className={style.tooltipTrigger}
        data-testid={testIds.tooltipTrigger}
        href={`#${tooltipId}`}
        role="button"
        aria-expanded={isOpen}
        aria-describedby={tooltipId}
        ref={popper.setRef}
        onClick={handleClick}
        onBlur={hideTooltip}
        onMouseOver={showTooltip}
        onMouseOut={hideTooltip}
      >
        <InfoIcon className={style.infoIcon} role="presentation" />
      </a>
      <div
        ref={popper.setPopper}
        style={popper.styles.popper}
        {...popper.attributes.popper}
        id={tooltipId}
        className={style.tooltip}
        data-testid={testIds.tooltip}
        role="tooltip"
        aria-live="polite"
      >
        <div>{props.message}</div>
        <TooltipArrow className={style.tooltipArrow} role="presentation" />
      </div>
    </div>
  );
};
